import type { ReactNode } from "react";
import { helpHome } from "../../app/help";
import { BrandLockup } from "../../components/BrandLockup";

export function AuthLayout({ title, children, footer }: { title: string; children: ReactNode; footer?: ReactNode }) {
  return (
    <div className="auth-page">
      <main className="auth-card" id="main">
        <BrandLockup variant="horizontal" />
        <h1>{title}</h1>
        {children}
        {footer && <div className="auth-footer">{footer}</div>}
      </main>
      <p className="auth-help">
        <a href={helpHome()} target="_blank" rel="noopener">
          Help center
        </a>
      </p>
    </div>
  );
}
